import { gql } from "apollo-boost";

export const FEATURED_CHEFS = gql`
  query featuredChefs($chefCount: Int) {
    featuredChefs(chefCount: $chefCount) {
      id
      emailId
      firstName
      lastName
      rating
      reviewCount
      canFly
      minEngagementPrice
      maxDiners
      active
      profilePic
      cuisines
      username
      cancellationPolicy { allowCancellation timeBeforeCancellation timeBeforeCancellationMetric penaltyCharge penaltyChargeMetric comments }
      verified
    }
  }
`;

export const GET_CHEF = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      emailId
      firstName
      lastName
      cellPhone
      profilePic
      dateOfBirth
      profilePic
    }
  }
`;

export const GET_CHEF_PAYMENT = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      paymentInfo {
        type
        card {
          cardId
          type
          last4
          expMonth
          expYear
        }
      }
    }
  }
`;

export const GET_CHEF_DETAILS = gql`
  query chef($id: ID!) {
    chef(id: $id) {
      id
      taxId
      firstName
      lastName
      emailId
      maxDiners
      story
      maxTravelDistance
      active
      cuisines
      saved
      minEngagementPrice
      hourlyPrice
      canFly
      completedSetupStep
      dateOfBirth
      profilePic
      rating
      reviewCount
      verified
      verificationInitiated
      cellPhone
      chefType
      chefPrivacyTerms
      username
      stripeStatus
      cancellationPolicy { allowCancellation timeBeforeCancellation timeBeforeCancellationMetric penaltyCharge penaltyChargeMetric comments }
      payoutInfoExists
      stripeRecipientAgreementAccepted
      identityDocuments {
        front
        back
      }
      stripeErrors {
        code
        reason
        requirement
      }
      s3 {
          failed
          fileName
          bucket
          processing
          processed
      }
      vimeoId
      vimeoLink
      vimeoFileName
      address {
        street1
        street2
        zip
        city
        state
      }
      media {
        url
        size
        type
      }
      dishesList {
        dishes {
          id
          name
          cuisines
          media {
            url
          }
        }
      }
      postsList {
        posts {
          id
          title
          body
          chefName
          numOfLikes
          postSlug
          media {
            url
          }
          createdAt
          updatedAt
        }
      }
      payoutMethod {
        accountId
        last4
        routingNumber
        bankName
      }
    }
  }
`;

export const GET_CHEF_BY_USERNAME = gql`
    query chefByUsername($username: String!) {
        chefByUsername(username: $username) {
            id
            taxId
            firstName
            lastName
            emailId
            maxDiners
            story
            maxTravelDistance
            active
            cuisines
            saved
            minEngagementPrice
            hourlyPrice
            canFly
            completedSetupStep
            dateOfBirth
            profilePic
            rating
            reviewCount
            verified
            cellPhone
            chefType
            username
            cancellationPolicy { allowCancellation timeBeforeCancellation timeBeforeCancellationMetric penaltyCharge penaltyChargeMetric comments }
            payoutInfoExists
            stripeRecipientAgreementAccepted
            identityDocuments {
                front
                back
            }
            s3 {
                failed
                fileName
                bucket
                processing
                processed
            }
            vimeoId
            vimeoLink
            vimeoFileName
            address {
                street1
                street2
                zip
                city
                state
            }
            media {
                url
                size
                type
            }
            dishesList {
                dishes {
                    id
                    name
                    cuisines
                    slug
                    media {
                        url
                    }
                }
            }
            postsList {
                posts {
                    id
                    title
                    body
                    chefName
                    numOfLikes
                    postSlug
                    media {
                        url
                    }
                    createdAt
                    updatedAt
                }
            }
            payoutMethod {
                accountId
                last4
                routingNumber
                bankName
            }
        }
    }
`;

export const GET_CHEF_WEEKLY_SCHEDULES = gql`
  query chefSchedule($chefId: ID!) {
    chefSchedule(chefId: $chefId) {
      daySchedules {
        day
        slots {
          start
          end
        }
      }
    }
  }
`;

export const GET_CHEF_DAY_SCHEDULES = gql`
  query chefSchedule($chefId: ID!, $date: String) {
    chefSchedule(chefId: $chefId, date: $date) {
      date
      available
      slots {
        start
        end
      }
    }
  }
`;

export const FIND_CHEF = gql`
  query findChefs(
    $filters: Filters!
    $cursor: String
    $pageSize: Int
    $next: String
    $previous: String
  ) {
    findChefs(
      filters: $filters
      cursor: $cursor
      pageSize: $pageSize
      next: $next
      previous: $previous
    ) {
      chefs {
        id
        emailId
        firstName
        lastName
        rating
        reviewCount
        canFly
        verified
        minEngagementPrice
        maxDiners
        active
        username
        cuisines
        cancellationPolicy { allowCancellation timeBeforeCancellation timeBeforeCancellationMetric penaltyCharge penaltyChargeMetric comments }
        profilePic
        stripeRecipientAgreementAccepted
        s3 {
            failed
            fileName
            bucket
            processing
            processed
        }
        vimeoId
        vimeoLink
        vimeoFileName
      }
      endCursor
      hasMore
    }
  }
`;

export const GET_CHEFS_BY_DISH = gql`
  query chefsByDish(
    $dishName: String!
    $pageSize: Int
    $next: String
    $previous: String
  ) {
    chefsByDish(
      dishName: $dishName
      pageSize: $pageSize
      next: $next
      previous: $previous
    ) {
      chefs {
        id
        firstName
        lastName
        emailId
        cellPhone
        profilePic
        chefType
        maxDiners
        canFly
        cuisines
        minEngagementPrice
        maxTravelDistance
        story
        username
        active
        verified
        rating
        reviewCount
        cancellationPolicy { allowCancellation timeBeforeCancellation timeBeforeCancellationMetric penaltyCharge penaltyChargeMetric comments }
        verified
        s3 {
            failed
            fileName
            bucket
            processing
            processed
        }
        vimeoId
        vimeoLink
        vimeoFileName
      }
      hasNext
      hasPrevious
      next
      previous
    }
  }
`;
export const GET_CHEF_AVAILABILITY = gql`
  query getChefAvailability($chefId: ID!, $date: Date) {
    getChefAvailability(chefId: $chefId, date: $date) {
      start
      end
    }
  }
`;

export const GET_CHEF_TRANSACTIONS = gql`
  query listChefTransactions($filters: TransactionFilters!, $cursor: String, $pageSize: Int!, $next: String, $previous: String) {
    listChefTransactions(filters: $filters, cursor: $cursor, pageSize: $pageSize, next: $next, previous: $previous) {
      transactions {
        date
        bookingId
        bookingDate  
        dinerName
        displayId
        type
        amount  
        serviceCharge  
      }
      endCursor
      hasMore
      hasNext
      hasPrevious
      next
      previous
    }
  }
`;

export const GET_CHEF_ACCOUNTING = gql`
    query fetchAccountingList($chefId: ID!) {
        fetchAccountingList(chefId: $chefId) {
            id
            chefId
            userId
            type
            amount
            transactionFee
            netAmount
            bookingId
            displayId
            bookingDate
            userName
        }
    }
`;

export const GET_SUBSCRIPTION_PLANS = gql`
  query productsList($userId: ID!) {
    productsList(userId: $userId) {
      id
      name
      stripeId
      description
      active
      priceScheme {
        id
        unit_amount
        product
        recurring {
          interval
          interval_count
        }
      }
    }
  }
`;

export const VALIDATE_COUPON = gql`
  query validateCoupon($coupon: String!) {
    validateCoupon(coupon: $coupon) {
      id
      couponId
      name
      duration
      amountOff
      percentOff
      monthCount
    }
  }
`;

export const FETCH_LAST_SUBSCRIPTION = gql`
  query fetchSubscription($chefId: ID!) {
    fetchSubscription(chefId: $chefId) {
      id
      isCancelled
      name
      duration
      durationType
      price
      startedOn
    }
  }
`;

export const FETCH_SUBSCRIPTION_LIST = gql`
  query fetchSubscriptionList($chefId: ID!) {
    fetchSubscriptionList(chefId: $chefId) {
      id
      subscriptionId
      isCancelled
      cancelledAt
      name
      duration
      durationType
      price
      startedOn
      didFailed
      failedAt
      priceId
      isScheduled
      scheduleDate
    }
  }
`;

export const FETCH_SUBSCRIPTION_PRORATION_DETAILS = gql`
  query subscriptionProrationDetails($subscriptionId: ID!, $priceId: ID!) {
    subscriptionProrationDetails(subscriptionId: $subscriptionId, priceId: $priceId) {
      amount_due
      amount_paid
      amount_remaining
      account_country
    }
  }
`;

